// Multivariate Dependencies
import React from 'react';
// Components
import { Container } from '../../../common/styles/container';
// Utils
import ReactDOM from 'react-dom';
import { ZIndex } from '../../../common/types/ZIndex';
import { ModalDialogStylePropertiesByVariant } from '../types/ModalDialogStylePropertiesByVariant';
// Hooks
import { useTheme } from 'styled-components';
// @todo: this needs to extend Modal or be deprecated / removed
// - we will need to change the interface and decouple it from LockScreen
export var ModalDialogStructure = function (_a) {
    var children = _a.children, className = _a.className;
    var theme = useTheme();
    var _b = ModalDialogStylePropertiesByVariant.default(theme), containerBackgroundColor = _b.containerBackgroundColor, contentBackgroundColor = _b.contentBackgroundColor;
    return ReactDOM.createPortal(React.createElement(Container, { className: className, backgroundColor: containerBackgroundColor, zIndex: ZIndex.COVER_BLOCK },
        React.createElement(Container, { width: 'fit-content', backgroundColor: contentBackgroundColor, borderRadius: '4px' }, children)), document.body);
};
//# sourceMappingURL=ModalDialogStructure.js.map